import fetch from '@/utils/fetch'

export function addNewNotice (data) {
  return fetch({
    url: '/addNewNotice',
    data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_notice.js